/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   1/11/21 1:52 PM
 */

import React from "react";
import {colors, Grid, Link, Typography, useTheme} from "@mui/material";
import Const from "./const.json";
import {format} from "./dates-helper";

export default function Footer() {

	const theme = useTheme();
	const itemSx = { ml: 1, mr: 1 }, textSx = { color: colors.grey[theme.palette.mode === "light" ? "500" : "700"] };

	return (
        <Grid container justifyContent={"center"} sx={{ mt: 2, mb: 2 }}>
			<Grid item sx={itemSx}>
				<Typography variant={"body2"}>
					<Link target="_blank" underline={"hover"} href={Const.URL_DOCS} sx={textSx}>
						Documentation
					</Link>
				</Typography>
			</Grid>
			<Grid item>
				<Typography variant={"body2"} color={textSx}>
					&#8226;
				</Typography>
			</Grid>
			<Grid item sx={itemSx}>
				<Typography variant={"body2"}>
					<Link target="_blank" underline={"hover"} href={Const.URL_SLACK_CHANNEL} sx={textSx}>
						{Const.SLACK_CHANNEL_NAME}
					</Link>
				</Typography>
			</Grid>
			<Grid item>
				<Typography variant={"body2"} sx={textSx}>
					&#8226;
				</Typography>
			</Grid>
			<Grid item sx={itemSx}>
				<Typography variant={"body2"}>
					<Link target="_blank" underline={"hover"} href="https://go.atlassian.com/vega" sx={textSx}>
						go/vega
					</Link>
				</Typography>
			</Grid>
			<Grid item>
				<Typography variant={"body2"} sx={textSx}>
					&#8226;
				</Typography>
			</Grid>
			<Grid item sx={itemSx}>
				<Typography variant={"body2"} sx={textSx}>
					v{process.env.REACT_APP_VERSION} ({format(Number(process.env.REACT_APP_BUILD_DATE), 'MMMM do, yyyy')})
				</Typography>
			</Grid>
		</Grid>
    );

}